<ol class="breadcrumb page-breadcrumb">
  <li class="breadcrumb-item">
    <a href="javascript:void(0);" [routerLink]="['/admin/home']">Home</a>
  </li>
  <li class="breadcrumb-item active">Leilão de Aulas</li>
  <li class="position-absolute pos-top pos-right d-none d-sm-block">
    <span class="js-get-date"></span>
  </li>
</ol>

<div class="subheader mb-2">
  <h1 class="subheader-title">
    <i class="subheader-icon fas fa-hammer"></i> Painel de
    <span class="fw-300">Leilões</span>
  </h1>
</div>
<div class="subheader mb-2">
  <h1>
    <small class="mb-2"> Visão geral do sistema de leilões de aulas </small>
  </h1>
</div>

<div class="row">
  <div class="col-12">
    <div class="card-deck">
      <div class="card">
        <div
          class="w-100 bg-primary rounded-top"
          style="padding: 4px 0 4px"
        ></div>
        <div class="card-body">
          <h5 class="card-title">Leilões Ativos</h5>
          <h2 class="card-text">{{ auctionDashboard.activeAuctions }}</h2>
        </div>
        <div class="card-footer">
          <small class="text-muted"
            >Última atualização em 13/11/2025 às 10:50:04</small
          >
        </div>
      </div>
      <div class="card">
        <div class="w-100 bg-info rounded-top" style="padding: 4px 0 4px"></div>
        <div class="card-body">
          <h5 class="card-title">Professores Registrados</h5>
          <h2 class="card-text">{{ auctionDashboard.registeredTeachers }}</h2>
        </div>
        <div class="card-footer">
          <small class="text-muted"
            >Última atualização em 13/11/2025 às 10:50:04</small
          >
        </div>
      </div>
      <div class="card">
        <div
          class="w-100 bg-success rounded-top"
          style="padding: 4px 0 4px"
        ></div>
        <div class="card-body">
          <h5 class="card-title">Aulas Preenchidas</h5>
          <h2 class="card-text">{{ auctionDashboard.classesFilled }}</h2>
        </div>
        <div class="card-footer">
          <small class="text-muted"
            >Última atualização em 13/11/2025 às 10:50:04</small
          >
        </div>
      </div>
      <div class="card">
        <div
          class="w-100 bg-warning rounded-top"
          style="padding: 4px 0 4px"
        ></div>
        <div class="card-body">
          <h5 class="card-title">Média de Lances</h5>
          <h2 class="card-text">{{ auctionDashboard.averageBids }}</h2>
        </div>
        <div class="card-footer">
          <small class="text-muted"
            >Última atualização em 13/11/2025 às 10:50:04</small
          >
        </div>
      </div>
    </div>
  </div>
</div>

<hr />

<div class="row">
  <div class="col-12">
    <h2 class="subheader-title">Leilões Ativos</h2>
  </div>
</div>
<!-- <div class="row">
  <div class="col-xl-12">
    <div id="panel-8" class="panel">
      <div class="panel-hdr bg-primary-600 bg-primary-gradient">
        <h2>Lista de Bancos</h2>
        <div class="panel-toolbar ml-2">
          <button
            type="button"
            class="btn btn-success btn-xs"
            data-toggle="tooltip"
            title="Novo Aluno"
            [routerLink]="['/admin/bank']"
          >
            Novo
          </button>
        </div>
      </div>
      <div class="panel-container show">
        <div
          class="panel-content py-2 rounded-bottom border-faded border-left-0 border-right-0 border-bottom-0 text-muted d-flex"
        >
          <div class="col-sm-12" *ngIf="!showTable">
            <div class="alert alert-warning m-2" role="alert">
              {{ returnMessage }}
            </div>
          </div>
          <div class="col-sm-12" *ngIf="showTable">
            <managed-table
              [dataTitle]=""
              [rows]="banks"
              [columns]="columns"
              [hasActions]="true"
              [ngTableFiltering]="true"
              [showFilterRow]="false"
              [previewEnable]="false"
              [editEnable]="true"
              [deleteEnable]="false"
              (editClick)="edit($event)"
              [hasFilter]="true"
            >
            </managed-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
